import React from "react"
import { EquifaxPrequalReport } from "@oneethos/shared"
import { CriteriaEvaluationResult } from "@oneethos/shared"
import { useState } from "react"
import { Evaluation, EvaluationSummary } from "./evaluation"

type EvaluationsProps = {
  evaluations: CriteriaEvaluationResult[]
  report: EquifaxPrequalReport
  sharedMonthlyDebt?: number
  showAll?: boolean
}

export const Evaluations = ({
  evaluations,
  report,
  sharedMonthlyDebt,
  showAll = false
}: EvaluationsProps) => {
  const [activeIdx, setActiveIdx] = useState<number | undefined>(undefined)

  return <div>
    <h5>Evaluations</h5>
    <div className="evaluations">
      <ul className="nav nav-underline">
        {evaluations.length === 0 ? <div className="alert alert-secondary">
          No evaluations found for this report
        </div> : null}
        {evaluations?.map((ev, idx) => (
          <li key={idx}
            className={`nav-item me-3`}
            onClick={() => {
              if (idx === activeIdx) {
                setActiveIdx(undefined)
              } else {
                setActiveIdx(idx)
              }
            }}
          >
            <div className={`nav-link ${idx === activeIdx ? 'active' : ''}`}>
              <EvaluationSummary
                evaluation={ev}
                report={report}
                sharedMonthlyDebt={sharedMonthlyDebt}
              />
            </div>
            {showAll ? <Evaluation
              evaluation={ev}
              report={report}
              sharedMonthlyDebt={sharedMonthlyDebt}
            /> : null}
          </li>
        ))}
      </ul>
      {activeIdx !== undefined ? <Evaluation
        evaluation={evaluations[activeIdx]}
        report={report}
        sharedMonthlyDebt={sharedMonthlyDebt}
      /> : null}
    </div>
  </div>
}

